import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  id?: string;
};

/** Hinweis, wenn der Hauptreisende am Anreisetag noch keine 18 Jahre alt ist. */
export function AgeRequirementNotice({ children, id }: Props) {
  return (
    <p id={id} className="bk-age-notice" role="alert">
      <span className="bk-age-notice__icon" aria-hidden="true">
        <svg viewBox="0 0 20 20" fill="none">
          <circle cx="10" cy="10" r="7.25" stroke="currentColor" strokeWidth="1.6" />
          <path d="M10 6.25v4.1" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
          <circle cx="10" cy="13.55" r="0.85" fill="currentColor" />
        </svg>
      </span>
      <span className="bk-age-notice__text">{children}</span>
    </p>
  );
}
